import { configureStore } from '@reduxjs/toolkit'
import authReducer from '../features/auth/lib/slice'
import dashboardReducer from '../features/dashboard/lib/slice'
export const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['auth/setAuthState'],
        ignoredPaths: ['auth.user', 'auth.session'],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch